/**
 * List of object types.
 */
export const OBJECT_TYPES = [
  'Extintor',
  'Alarma',
  'Pulsador',
  'Sirena',
  'Detector de humo',
  'Hidrante',
  'Válvula de seccionamiento',
  'Escotillas',
  'Lava ojos',
  'Burritos',
  "Imán"
];

/**
 * List of object types prefix.
 */
export const OBJECT_TYPE_PREFIXS = [
  'EX',
  'AL',
  'PL',
  'SI',
  'DH',
  'HI',
  'VS',
  'HT',
  'EW',
  'RL',
  'IM'
];

export class CheckObjectType {
  static isExtinguisher(objectTypeId: number): boolean {
    return objectTypeId === 1;
  };
  static isAlarm(objectTypeId: number): boolean {
    return objectTypeId === 2;
  };
  static isPushButton(objectTypeId: number): boolean {
    return objectTypeId === 3;
  };
  static isSiren(objectTypeId: number): boolean {
    return objectTypeId === 4;
  };
  static isSmokeDetector(objectTypeId: number): boolean {
    return objectTypeId === 5;
  };
  static isHydrant(objectTypeId: number): boolean {
    return objectTypeId === 6;
  };
  static isSectionalValve(objectTypeId: number): boolean {
    return objectTypeId === 7;
  };
  static isHatch(objectTypeId: number): boolean {
    return objectTypeId === 8;
  };
  static isEyewashes(objectTypeId: number): boolean {
    return objectTypeId === 9;
  };
  static isRollingLadders(objectTypeId: number): boolean {
    return objectTypeId === 10;
  };
  static isMagnet(objectTypeId: number): boolean {
    return objectTypeId === 11;
  };
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/object-type.interface.ts